import {
  configApiRef,
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { alertingApiRef } from './api/alerting/alerting-api';
import { AlertingApiClient } from './api/alerting/alerting-api-client';
import { detailsApiRef } from './api/details/details-api';
import { DetailsApiClient } from './api/details/details-api-client';
import { metricsApiRef } from './api/metrics/metrics-api';
import { MetricsApiClient } from './api/metrics/metrics-api-client';

export const metricsAlertingInsightsPlugin = createPlugin({
  id: 'metrics-alerting-insights',
  apis: [
    createApiFactory({
      api: alertingApiRef,
      deps: { configApi: configApiRef, identityApi: identityApiRef },
      factory: ({ configApi, identityApi }) =>
        new AlertingApiClient(configApi, identityApi),
    }),
    createApiFactory({
      api: detailsApiRef,
      deps: { configApi: configApiRef, identityApi: identityApiRef },
      factory: ({ configApi, identityApi }) =>
        new DetailsApiClient(configApi, identityApi),
    }),
    createApiFactory({
      api: metricsApiRef,
      deps: { configApi: configApiRef, identityApi: identityApiRef },
      factory: ({ configApi, identityApi }) =>
        new MetricsApiClient(configApi, identityApi),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const MetricsAlertingInsightsPage =
  metricsAlertingInsightsPlugin.provide(
    createRoutableExtension({
      name: 'MetricsAlertingInsightsPage',
      component: () =>
        import('./components/').then(m => m.MetricsAlertingInsightsPage),
      mountPoint: rootRouteRef,
    }),
  );
